export class DashboardData {
    surveyUId: string;
    surveyCode: string;
    formFields: DashboardDataFormField[];
    constructor() {
        this.surveyUId = '';
        this.surveyCode = '';
        this.formFields = [];
    }
}

export class DashboardDataFormField {
    index: number;
    label: string;
    usedForFilter: boolean;
    useCustomOptionOrder: boolean;
    options : []
    constructor(index: number, label : string, usedForFilter : boolean, useCustomOptionOrder: boolean) {
        this.index = index;
        this.label= label;
        this.usedForFilter = usedForFilter;
        this.useCustomOptionOrder = useCustomOptionOrder;
        this.options = [];
    }
}

